var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"color":"#FFFFFF"}},[_c('v-row',{attrs:{"align":"center"}},[_c('v-col',{staticClass:"text-center overline font-weight-thin"},[_c('v-divider',{staticClass:"my-5"}),_vm._v(" 技大祭実行委員会 ")],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }